// AUTO-GENERATED by scripts/generate-lucide-icons.js — do not edit manually
// 265 icon module(s) detected from source scan (279 name(s) including Lucide aliases)
//
// To regenerate: node scripts/generate-lucide-icons.js
// To check if up-to-date: node scripts/generate-lucide-icons.js --check

import { createIcons } from './create-icons.js';

// Per-icon imports to avoid pulling in the full lucide barrel (1,600+ icons)
import { default as Activity } from 'lucide/dist/esm/icons/activity.mjs';
import { default as AlarmClock } from 'lucide/dist/esm/icons/alarm-clock.mjs';
import { default as AlertCircle } from 'lucide/dist/esm/icons/circle-alert.mjs';
import { default as AlertTriangle } from 'lucide/dist/esm/icons/triangle-alert.mjs';
import { default as Archive } from 'lucide/dist/esm/icons/archive.mjs';
import { default as ArchiveRestore } from 'lucide/dist/esm/icons/archive-restore.mjs';
import { default as ArrowDown } from 'lucide/dist/esm/icons/arrow-down.mjs';
import { default as ArrowDownUp } from 'lucide/dist/esm/icons/arrow-down-up.mjs';
import { default as ArrowLeft } from 'lucide/dist/esm/icons/arrow-left.mjs';
import { default as ArrowLeftRight } from 'lucide/dist/esm/icons/arrow-left-right.mjs';
import { default as ArrowRight } from 'lucide/dist/esm/icons/arrow-right.mjs';
import { default as ArrowUp } from 'lucide/dist/esm/icons/arrow-up.mjs';
import { default as ArrowUpDown } from 'lucide/dist/esm/icons/arrow-up-down.mjs';
import { default as Asterisk } from 'lucide/dist/esm/icons/asterisk.mjs';
import { default as AtSign } from 'lucide/dist/esm/icons/at-sign.mjs';
import { default as BadgeCheck } from 'lucide/dist/esm/icons/badge-check.mjs';
import { default as Ban } from 'lucide/dist/esm/icons/ban.mjs';
import { default as Beer } from 'lucide/dist/esm/icons/beer.mjs';
import { default as Bell } from 'lucide/dist/esm/icons/bell.mjs';
import { default as BellOff } from 'lucide/dist/esm/icons/bell-off.mjs';
import { default as Book } from 'lucide/dist/esm/icons/book.mjs';
import { default as Bookmark } from 'lucide/dist/esm/icons/bookmark.mjs';
import { default as BookmarkMinus } from 'lucide/dist/esm/icons/bookmark-minus.mjs';
import { default as BookOpen } from 'lucide/dist/esm/icons/book-open.mjs';
import { default as Bot } from 'lucide/dist/esm/icons/bot.mjs';
import { default as Box } from 'lucide/dist/esm/icons/box.mjs';
import { default as Briefcase } from 'lucide/dist/esm/icons/briefcase.mjs';
import { default as Bug } from 'lucide/dist/esm/icons/bug.mjs';
import { default as Building } from 'lucide/dist/esm/icons/building.mjs';
import { default as Building2 } from 'lucide/dist/esm/icons/building-complex.mjs';
import { default as Cake } from 'lucide/dist/esm/icons/cake.mjs';
import { default as Calendar } from 'lucide/dist/esm/icons/calendar.mjs';
import { default as CalendarDays } from 'lucide/dist/esm/icons/calendar-days.mjs';
import { default as CalendarPlus } from 'lucide/dist/esm/icons/calendar-plus.mjs';
import { default as CalendarX } from 'lucide/dist/esm/icons/calendar-x.mjs';
import { default as Camera } from 'lucide/dist/esm/icons/camera.mjs';
import { default as Check } from 'lucide/dist/esm/icons/check.mjs';
import { default as CheckCheck } from 'lucide/dist/esm/icons/check-check.mjs';
import { default as CheckCircle } from 'lucide/dist/esm/icons/circle-check-big.mjs';
import { default as CheckCircle2 } from 'lucide/dist/esm/icons/circle-check.mjs';
import { default as CheckSquare } from 'lucide/dist/esm/icons/square-check-big.mjs';
import { default as ChevronDown } from 'lucide/dist/esm/icons/chevron-down.mjs';
import { default as ChevronLeft } from 'lucide/dist/esm/icons/chevron-left.mjs';
import { default as ChevronRight } from 'lucide/dist/esm/icons/chevron-right.mjs';
import { default as ChevronsDownUp } from 'lucide/dist/esm/icons/chevrons-down-up.mjs';
import { default as ChevronsLeft } from 'lucide/dist/esm/icons/chevrons-left.mjs';
import { default as ChevronsUpDown } from 'lucide/dist/esm/icons/chevrons-up-down.mjs';
import { default as ChevronUp } from 'lucide/dist/esm/icons/chevron-up.mjs';
import { default as Circle } from 'lucide/dist/esm/icons/circle.mjs';
import { default as CircleDot } from 'lucide/dist/esm/icons/circle-dot.mjs';
import { default as CircleHelp } from 'lucide/dist/esm/icons/circle-question-mark.mjs';
import { default as CircleMinus } from 'lucide/dist/esm/icons/circle-minus.mjs';
import { default as CirclePlay } from 'lucide/dist/esm/icons/circle-play.mjs';
import { default as CircleSlash } from 'lucide/dist/esm/icons/circle-slash.mjs';
import { default as CircleStop } from 'lucide/dist/esm/icons/circle-stop.mjs';
import { default as CircleX } from 'lucide/dist/esm/icons/circle-x.mjs';
import { default as Clapperboard } from 'lucide/dist/esm/icons/clapperboard.mjs';
import { default as ClipboardCheck } from 'lucide/dist/esm/icons/clipboard-check.mjs';
import { default as ClipboardList } from 'lucide/dist/esm/icons/clipboard-list.mjs';
import { default as Clock } from 'lucide/dist/esm/icons/clock.mjs';
import { default as ClockAlert } from 'lucide/dist/esm/icons/clock-alert.mjs';
import { default as Code } from 'lucide/dist/esm/icons/code.mjs';
import { default as Coffee } from 'lucide/dist/esm/icons/coffee.mjs';
import { default as Compass } from 'lucide/dist/esm/icons/compass.mjs';
import { default as Cookie } from 'lucide/dist/esm/icons/cookie.mjs';
import { default as Copy } from 'lucide/dist/esm/icons/copy.mjs';
import { default as CornerDownRight } from 'lucide/dist/esm/icons/corner-down-right.mjs';
import { default as CornerUpLeft } from 'lucide/dist/esm/icons/corner-up-left.mjs';
import { default as Cpu } from 'lucide/dist/esm/icons/cpu.mjs';
import { default as CreditCard } from 'lucide/dist/esm/icons/credit-card.mjs';
import { default as Crop } from 'lucide/dist/esm/icons/crop.mjs';
import { default as Crosshair } from 'lucide/dist/esm/icons/crosshair.mjs';
import { default as Crown } from 'lucide/dist/esm/icons/crown.mjs';
import { default as Dot } from 'lucide/dist/esm/icons/dot.mjs';
import { default as Download } from 'lucide/dist/esm/icons/download.mjs';
import { default as Ellipsis } from 'lucide/dist/esm/icons/ellipsis.mjs';
import { default as EllipsisVertical } from 'lucide/dist/esm/icons/ellipsis-vertical.mjs';
import { default as Eraser } from 'lucide/dist/esm/icons/eraser.mjs';
import { default as ExternalLink } from 'lucide/dist/esm/icons/external-link.mjs';
import { default as Eye } from 'lucide/dist/esm/icons/eye.mjs';
import { default as EyeOff } from 'lucide/dist/esm/icons/eye-off.mjs';
import { default as FileText } from 'lucide/dist/esm/icons/file-text.mjs';
import { default as FileX } from 'lucide/dist/esm/icons/file-x.mjs';
import { default as Film } from 'lucide/dist/esm/icons/film.mjs';
import { default as Filter } from 'lucide/dist/esm/icons/funnel.mjs';
import { default as Fingerprint } from 'lucide/dist/esm/icons/fingerprint-pattern.mjs';
import { default as Flag } from 'lucide/dist/esm/icons/flag.mjs';
import { default as FlagOff } from 'lucide/dist/esm/icons/flag-off.mjs';
import { default as Flame } from 'lucide/dist/esm/icons/flame.mjs';
import { default as FlaskConical } from 'lucide/dist/esm/icons/flask-conical.mjs';
import { default as Folder } from 'lucide/dist/esm/icons/folder.mjs';
import { default as FolderInput } from 'lucide/dist/esm/icons/folder-input.mjs';
import { default as FolderOpen } from 'lucide/dist/esm/icons/folder-open.mjs';
import { default as FolderPlus } from 'lucide/dist/esm/icons/folder-plus.mjs';
import { default as Gamepad2 } from 'lucide/dist/esm/icons/gamepad-2.mjs';
import { default as Gavel } from 'lucide/dist/esm/icons/gavel.mjs';
import { default as Ghost } from 'lucide/dist/esm/icons/ghost.mjs';
import { default as GitBranch } from 'lucide/dist/esm/icons/git-branch.mjs';
import { default as GitMerge } from 'lucide/dist/esm/icons/git-merge.mjs';
import { default as Globe } from 'lucide/dist/esm/icons/globe.mjs';
import { default as GraduationCap } from 'lucide/dist/esm/icons/graduation-cap.mjs';
import { default as Grid2x2 } from 'lucide/dist/esm/icons/grid-2x2.mjs';
import { default as HandHeart } from 'lucide/dist/esm/icons/hand-heart.mjs';
import { default as Handshake } from 'lucide/dist/esm/icons/handshake.mjs';
import { default as HatGlasses } from 'lucide/dist/esm/icons/hat-glasses.mjs';
import { default as Heading } from 'lucide/dist/esm/icons/heading.mjs';
import { default as Headphones } from 'lucide/dist/esm/icons/headphones.mjs';
import { default as Heart } from 'lucide/dist/esm/icons/heart.mjs';
import { default as HeartHandshake } from 'lucide/dist/esm/icons/heart-handshake.mjs';
import { default as HeartOff } from 'lucide/dist/esm/icons/heart-off.mjs';
import { default as HeartPulse } from 'lucide/dist/esm/icons/heart-pulse.mjs';
import { default as History } from 'lucide/dist/esm/icons/rotate-ccw-clock.mjs';
import { default as Home } from 'lucide/dist/esm/icons/house.mjs';
import { default as Hourglass } from 'lucide/dist/esm/icons/hourglass.mjs';
import { default as Image } from 'lucide/dist/esm/icons/image.mjs';
import { default as ImageOff } from 'lucide/dist/esm/icons/image-off.mjs';
import { default as ImagePlus } from 'lucide/dist/esm/icons/image-plus.mjs';
import { default as Images } from 'lucide/dist/esm/icons/images.mjs';
import { default as Inbox } from 'lucide/dist/esm/icons/inbox.mjs';
import { default as Info } from 'lucide/dist/esm/icons/info.mjs';
import { default as Key } from 'lucide/dist/esm/icons/key.mjs';
import { default as KeyRound } from 'lucide/dist/esm/icons/key-round.mjs';
import { default as Languages } from 'lucide/dist/esm/icons/languages.mjs';
import { default as Laptop } from 'lucide/dist/esm/icons/laptop.mjs';
import { default as Layers } from 'lucide/dist/esm/icons/layers.mjs';
import { default as LayoutTemplate } from 'lucide/dist/esm/icons/layout-template.mjs';
import { default as Lightbulb } from 'lucide/dist/esm/icons/lightbulb.mjs';
import { default as Link } from 'lucide/dist/esm/icons/link.mjs';
import { default as List } from 'lucide/dist/esm/icons/list.mjs';
import { default as ListChecks } from 'lucide/dist/esm/icons/list-checks.mjs';
import { default as Loader2 } from 'lucide/dist/esm/icons/loader-circle.mjs';
import { default as LocateFixed } from 'lucide/dist/esm/icons/locate-fixed.mjs';
import { default as Lock } from 'lucide/dist/esm/icons/lock.mjs';
import { default as LogIn } from 'lucide/dist/esm/icons/log-in.mjs';
import { default as LogOut } from 'lucide/dist/esm/icons/log-out.mjs';
import { default as Mail } from 'lucide/dist/esm/icons/mail.mjs';
import { default as MailCheck } from 'lucide/dist/esm/icons/mail-check.mjs';
import { default as MailPlus } from 'lucide/dist/esm/icons/mail-plus.mjs';
import { default as MailWarning } from 'lucide/dist/esm/icons/mail-warning.mjs';
import { default as MailX } from 'lucide/dist/esm/icons/mail-x.mjs';
import { default as Map } from 'lucide/dist/esm/icons/map.mjs';
import { default as MapPin } from 'lucide/dist/esm/icons/map-pin.mjs';
import { default as MapPinOff } from 'lucide/dist/esm/icons/map-pin-off.mjs';
import { default as Mars } from 'lucide/dist/esm/icons/mars.mjs';
import { default as Megaphone } from 'lucide/dist/esm/icons/megaphone.mjs';
import { default as MessageCircle } from 'lucide/dist/esm/icons/message-circle.mjs';
import { default as MessageCircleHeart } from 'lucide/dist/esm/icons/message-circle-heart.mjs';
import { default as MessageCircleOff } from 'lucide/dist/esm/icons/message-circle-off.mjs';
import { default as MessageSquare } from 'lucide/dist/esm/icons/message-square.mjs';
import { default as MessageSquarePlus } from 'lucide/dist/esm/icons/message-square-plus.mjs';
import { default as MessageSquareShare } from 'lucide/dist/esm/icons/message-square-share.mjs';
import { default as MessageSquareText } from 'lucide/dist/esm/icons/message-square-text.mjs';
import { default as MessageSquareWarning } from 'lucide/dist/esm/icons/message-square-warning.mjs';
import { default as MessagesSquare } from 'lucide/dist/esm/icons/messages-square.mjs';
import { default as Mic } from 'lucide/dist/esm/icons/mic.mjs';
import { default as MicOff } from 'lucide/dist/esm/icons/mic-off.mjs';
import { default as Minus } from 'lucide/dist/esm/icons/minus.mjs';
import { default as Monitor } from 'lucide/dist/esm/icons/monitor.mjs';
import { default as MonitorSmartphone } from 'lucide/dist/esm/icons/monitor-smartphone.mjs';
import { default as Moon } from 'lucide/dist/esm/icons/moon.mjs';
import { default as MoveHorizontal } from 'lucide/dist/esm/icons/move-horizontal.mjs';
import { default as Music } from 'lucide/dist/esm/icons/eighth-notes.mjs';
import { default as Navigation } from 'lucide/dist/esm/icons/navigation.mjs';
import { default as Newspaper } from 'lucide/dist/esm/icons/newspaper.mjs';
import { default as Palette } from 'lucide/dist/esm/icons/palette.mjs';
import { default as PanelRightOpen } from 'lucide/dist/esm/icons/panel-right-open.mjs';
import { default as PanelsTopLeft } from 'lucide/dist/esm/icons/panels-top-left.mjs';
import { default as Paperclip } from 'lucide/dist/esm/icons/paperclip.mjs';
import { default as PartyPopper } from 'lucide/dist/esm/icons/party-popper.mjs';
import { default as Pause } from 'lucide/dist/esm/icons/pause.mjs';
import { default as PauseCircle } from 'lucide/dist/esm/icons/circle-pause.mjs';
import { default as PawPrint } from 'lucide/dist/esm/icons/paw-print.mjs';
import { default as Pencil } from 'lucide/dist/esm/icons/pencil.mjs';
import { default as PencilLine } from 'lucide/dist/esm/icons/pencil-line.mjs';
import { default as Phone } from 'lucide/dist/esm/icons/phone.mjs';
import { default as PhoneIncoming } from 'lucide/dist/esm/icons/phone-incoming.mjs';
import { default as PhoneMissed } from 'lucide/dist/esm/icons/phone-missed.mjs';
import { default as PhoneOff } from 'lucide/dist/esm/icons/phone-off.mjs';
import { default as PhoneOutgoing } from 'lucide/dist/esm/icons/phone-outgoing.mjs';
import { default as Pill } from 'lucide/dist/esm/icons/pill.mjs';
import { default as Pin } from 'lucide/dist/esm/icons/pin.mjs';
import { default as PinOff } from 'lucide/dist/esm/icons/pin-off.mjs';
import { default as Plane } from 'lucide/dist/esm/icons/plane.mjs';
import { default as Play } from 'lucide/dist/esm/icons/play.mjs';
import { default as Plus } from 'lucide/dist/esm/icons/plus.mjs';
import { default as PlusCircle } from 'lucide/dist/esm/icons/circle-plus.mjs';
import { default as Quote } from 'lucide/dist/esm/icons/quote.mjs';
import { default as Radio } from 'lucide/dist/esm/icons/radio.mjs';
import { default as RefreshCw } from 'lucide/dist/esm/icons/refresh-cw.mjs';
import { default as Repeat } from 'lucide/dist/esm/icons/repeat.mjs';
import { default as Reply } from 'lucide/dist/esm/icons/reply.mjs';
import { default as RotateCcw } from 'lucide/dist/esm/icons/rotate-ccw.mjs';
import { default as RotateCw } from 'lucide/dist/esm/icons/rotate-cw.mjs';
import { default as Route } from 'lucide/dist/esm/icons/route.mjs';
import { default as Scale } from 'lucide/dist/esm/icons/scale.mjs';
import { default as ScanEye } from 'lucide/dist/esm/icons/scan-eye.mjs';
import { default as ScanFace } from 'lucide/dist/esm/icons/scan-face.mjs';
import { default as ScanSearch } from 'lucide/dist/esm/icons/scan-search.mjs';
import { default as ScrollText } from 'lucide/dist/esm/icons/scroll-text.mjs';
import { default as Search } from 'lucide/dist/esm/icons/search.mjs';
import { default as SearchX } from 'lucide/dist/esm/icons/search-x.mjs';
import { default as Send } from 'lucide/dist/esm/icons/send.mjs';
import { default as SendHorizontal } from 'lucide/dist/esm/icons/send-horizontal.mjs';
import { default as Settings } from 'lucide/dist/esm/icons/settings.mjs';
import { default as Settings2 } from 'lucide/dist/esm/icons/settings-2.mjs';
import { default as Share } from 'lucide/dist/esm/icons/share.mjs';
import { default as Share2 } from 'lucide/dist/esm/icons/share-2.mjs';
import { default as Shield } from 'lucide/dist/esm/icons/shield.mjs';
import { default as ShieldAlert } from 'lucide/dist/esm/icons/shield-alert.mjs';
import { default as ShieldCheck } from 'lucide/dist/esm/icons/shield-check.mjs';
import { default as ShieldOff } from 'lucide/dist/esm/icons/shield-off.mjs';
import { default as Shirt } from 'lucide/dist/esm/icons/shirt.mjs';
import { default as SlidersHorizontal } from 'lucide/dist/esm/icons/sliders-horizontal.mjs';
import { default as Smartphone } from 'lucide/dist/esm/icons/smartphone.mjs';
import { default as Smile } from 'lucide/dist/esm/icons/face-slightly-smiling.mjs';
import { default as SmilePlus } from 'lucide/dist/esm/icons/face-slightly-smiling-plus.mjs';
import { default as Snowflake } from 'lucide/dist/esm/icons/snowflake.mjs';
import { default as Sparkles } from 'lucide/dist/esm/icons/sparkles.mjs';
import { default as SpellCheck } from 'lucide/dist/esm/icons/spell-check.mjs';
import { default as Square } from 'lucide/dist/esm/icons/square.mjs';
import { default as SquarePen } from 'lucide/dist/esm/icons/square-pen.mjs';
import { default as Star } from 'lucide/dist/esm/icons/star.mjs';
import { default as StickyNote } from 'lucide/dist/esm/icons/sticky-note.mjs';
import { default as Sun } from 'lucide/dist/esm/icons/sun.mjs';
import { default as SwitchCamera } from 'lucide/dist/esm/icons/switch-camera.mjs';
import { default as Tablet } from 'lucide/dist/esm/icons/tablet.mjs';
import { default as Tag } from 'lucide/dist/esm/icons/tag.mjs';
import { default as Tags } from 'lucide/dist/esm/icons/tags.mjs';
import { default as Target } from 'lucide/dist/esm/icons/target.mjs';
import { default as TextSearch } from 'lucide/dist/esm/icons/text-search.mjs';
import { default as ThumbsDown } from 'lucide/dist/esm/icons/thumbs-down.mjs';
import { default as ThumbsUp } from 'lucide/dist/esm/icons/thumbs-up.mjs';
import { default as Timer } from 'lucide/dist/esm/icons/timer.mjs';
import { default as TimerOff } from 'lucide/dist/esm/icons/timer-off.mjs';
import { default as Trash } from 'lucide/dist/esm/icons/trash.mjs';
import { default as Trophy } from 'lucide/dist/esm/icons/trophy.mjs';
import { default as Truck } from 'lucide/dist/esm/icons/truck.mjs';
import { default as Tv } from 'lucide/dist/esm/icons/tv.mjs';
import { default as Type } from 'lucide/dist/esm/icons/type.mjs';
import { default as Undo2 } from 'lucide/dist/esm/icons/undo-2.mjs';
import { default as Unlock } from 'lucide/dist/esm/icons/lock-open.mjs';
import { default as Upload } from 'lucide/dist/esm/icons/upload.mjs';
import { default as User } from 'lucide/dist/esm/icons/user.mjs';
import { default as UserCheck } from 'lucide/dist/esm/icons/user-check.mjs';
import { default as UserCircle } from 'lucide/dist/esm/icons/circle-user.mjs';
import { default as UserCog } from 'lucide/dist/esm/icons/user-cog.mjs';
import { default as UserMinus } from 'lucide/dist/esm/icons/user-minus.mjs';
import { default as UserPen } from 'lucide/dist/esm/icons/user-pen.mjs';
import { default as UserPlus } from 'lucide/dist/esm/icons/user-plus.mjs';
import { default as UserRound } from 'lucide/dist/esm/icons/user-round.mjs';
import { default as UserRoundCheck } from 'lucide/dist/esm/icons/user-round-check.mjs';
import { default as UserRoundCog } from 'lucide/dist/esm/icons/user-round-cog.mjs';
import { default as UserRoundPlus } from 'lucide/dist/esm/icons/user-round-plus.mjs';
import { default as Users } from 'lucide/dist/esm/icons/users.mjs';
import { default as Users2 } from 'lucide/dist/esm/icons/users-round.mjs';
import { default as UserX } from 'lucide/dist/esm/icons/user-x.mjs';
import { default as Utensils } from 'lucide/dist/esm/icons/utensils.mjs';
import { default as VenetianMask } from 'lucide/dist/esm/icons/venetian-mask.mjs';
import { default as Venus } from 'lucide/dist/esm/icons/venus.mjs';
import { default as Video } from 'lucide/dist/esm/icons/video.mjs';
import { default as VideoOff } from 'lucide/dist/esm/icons/video-off.mjs';
import { default as Volume2 } from 'lucide/dist/esm/icons/volume-2.mjs';
import { default as WifiOff } from 'lucide/dist/esm/icons/wifi-off.mjs';
import { default as X } from 'lucide/dist/esm/icons/x.mjs';
import { default as Zap } from 'lucide/dist/esm/icons/zap.mjs';

export const icons = {
    Activity,
    AlarmClock,
    AlertCircle,
    CircleAlert: AlertCircle,
    AlertTriangle,
    TriangleAlert: AlertTriangle,
    Archive,
    ArchiveRestore,
    ArrowDown,
    ArrowDownUp,
    ArrowLeft,
    ArrowLeftRight,
    ArrowRight,
    ArrowUp,
    ArrowUpDown,
    Asterisk,
    AtSign,
    BadgeCheck,
    Ban,
    Beer,
    Bell,
    BellOff,
    Book,
    Bookmark,
    BookmarkMinus,
    BookOpen,
    Bot,
    Box,
    Briefcase,
    Bug,
    Building,
    Building2,
    Cake,
    Calendar,
    CalendarDays,
    CalendarPlus,
    CalendarX,
    Camera,
    Check,
    CheckCheck,
    CheckCircle,
    CircleCheckBig: CheckCircle,
    CheckCircle2,
    CircleCheck: CheckCircle2,
    CheckSquare,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsDownUp,
    ChevronsLeft,
    ChevronsUpDown,
    ChevronUp,
    Circle,
    CircleDot,
    CircleHelp,
    HelpCircle: CircleHelp,
    CircleMinus,
    MinusCircle: CircleMinus,
    CirclePlay,
    PlayCircle: CirclePlay,
    CircleSlash,
    CircleStop,
    CircleX,
    XCircle: CircleX,
    Clapperboard,
    ClipboardCheck,
    ClipboardList,
    Clock,
    ClockAlert,
    Code,
    Coffee,
    Compass,
    Cookie,
    Copy,
    CornerDownRight,
    CornerUpLeft,
    Cpu,
    CreditCard,
    Crop,
    Crosshair,
    Crown,
    Dot,
    Download,
    Ellipsis,
    MoreHorizontal: Ellipsis,
    EllipsisVertical,
    Eraser,
    ExternalLink,
    Eye,
    EyeOff,
    FileText,
    FileX,
    Film,
    Filter,
    Fingerprint,
    Flag,
    FlagOff,
    Flame,
    FlaskConical,
    Folder,
    FolderInput,
    FolderOpen,
    FolderPlus,
    Gamepad2,
    Gavel,
    Ghost,
    GitBranch,
    GitMerge,
    Globe,
    GraduationCap,
    Grid2x2,
    HandHeart,
    Handshake,
    HatGlasses,
    Heading,
    Headphones,
    Heart,
    HeartHandshake,
    HeartOff,
    HeartPulse,
    History,
    Home,
    House: Home,
    Hourglass,
    Image,
    ImageOff,
    ImagePlus,
    Images,
    Inbox,
    Info,
    Key,
    KeyRound,
    Languages,
    Laptop,
    Layers,
    Layers3: Layers,
    LayoutTemplate,
    Lightbulb,
    Link,
    List,
    ListChecks,
    Loader2,
    LoaderCircle: Loader2,
    LocateFixed,
    Lock,
    LogIn,
    LogOut,
    Mail,
    MailCheck,
    MailPlus,
    MailWarning,
    MailX,
    Map,
    MapPin,
    MapPinOff,
    Mars,
    Megaphone,
    MessageCircle,
    MessageCircleHeart,
    MessageCircleOff,
    MessageSquare,
    MessageSquarePlus,
    MessageSquareShare,
    MessageSquareText,
    MessageSquareWarning,
    MessagesSquare,
    Mic,
    MicOff,
    Minus,
    Monitor,
    MonitorSmartphone,
    Moon,
    MoveHorizontal,
    Music,
    Navigation,
    Newspaper,
    Palette,
    PanelRightOpen,
    PanelsTopLeft,
    Paperclip,
    PartyPopper,
    Pause,
    PauseCircle,
    PawPrint,
    Pencil,
    PencilLine,
    Phone,
    PhoneIncoming,
    PhoneMissed,
    PhoneOff,
    PhoneOutgoing,
    Pill,
    Pin,
    PinOff,
    Plane,
    Play,
    Plus,
    PlusCircle,
    Quote,
    Radio,
    RefreshCw,
    Repeat,
    Reply,
    RotateCcw,
    RotateCw,
    Route,
    Scale,
    ScanEye,
    ScanFace,
    ScanSearch,
    ScrollText,
    Search,
    SearchX,
    Send,
    SendHorizontal,
    Settings,
    Settings2,
    Share,
    Share2,
    Shield,
    ShieldAlert,
    ShieldCheck,
    ShieldOff,
    Shirt,
    SlidersHorizontal,
    Smartphone,
    Smile,
    SmilePlus,
    Snowflake,
    Sparkles,
    SpellCheck,
    Square,
    SquarePen,
    Star,
    StickyNote,
    Sun,
    SwitchCamera,
    Tablet,
    Tag,
    Tags,
    Target,
    TextSearch,
    ThumbsDown,
    ThumbsUp,
    Timer,
    TimerOff,
    Trash,
    Trash2: Trash,
    Trophy,
    Truck,
    Tv,
    Type,
    Undo2,
    Unlock,
    Upload,
    User,
    UserCheck,
    UserCircle,
    UserCog,
    UserMinus,
    UserPen,
    UserPlus,
    UserRound,
    UserRoundCheck,
    UserRoundCog,
    UserRoundPlus,
    Users,
    Users2,
    UsersRound: Users2,
    UserX,
    Utensils,
    VenetianMask,
    Venus,
    Video,
    VideoOff,
    Volume2,
    WifiOff,
    X,
    Zap
};

export { createIcons };
